import 'mdn-polyfills/NodeList.prototype.forEach';

export default class Share {
  constructor(element) {
    this.element = element;
    this.button = document.querySelector(".c-button--share");
    this.shareUrl = document.querySelector(".c-button--share").getAttribute("data-share");
    this.buttonIcon = this.button.querySelector(".c-button__icon");
    this.buttonLabel = this.button.querySelector(".c-button__label");

    this.svgColler = '<svg width="16" height="16" aria-hidden="true"><path fill="currentColor" d="M15.533 4.718a.747.747 0 0 0-1.058 0l-7.717 7.717L3.54 9.217a.748.748 0 0 0-1.057 1.058l3.75 3.75a.747.747 0 0 0 1.057 0l8.243-8.242a.747.747 0 0 0 0-1.058v-.007Z"/></svg>';
    this.svgDefault = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none"><path fill="currentColor" d="M12.375 13.688h-1.132a.567.567 0 0 1-.563-.563c0-.307.255-.563.563-.563h1.132A3.566 3.566 0 0 0 15.938 9a3.566 3.566 0 0 0-3.563-3.563H11.25a.562.562 0 1 1 0-1.125h1.125A4.69 4.69 0 0 1 17.063 9a4.69 4.69 0 0 1-4.688 4.688ZM6.75 13.688H5.625A4.69 4.69 0 0 1 .937 9a4.69 4.69 0 0 1 4.688-4.688H6.75c.308 0 .563.255.563.563a.567.567 0 0 1-.563.563H5.625A3.566 3.566 0 0 0 2.062 9a3.566 3.566 0 0 0 3.563 3.563H6.75c.308 0 .563.255.563.562a.567.567 0 0 1-.563.563Z"/><path fill="currentColor" d="M12 9.563H6A.567.567 0 0 1 5.437 9c0-.307.255-.563.563-.563h6c.307 0 .563.256.563.563a.567.567 0 0 1-.563.563Z"/></svg>';
    this.svgShare = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18"> <path fill="currentColor" fill-rule="evenodd" d="M14.25 11.25c-1.095 0-2.04.592-2.565 1.463l-5.16-2.58A3.02 3.02 0 0 0 6.75 9c0-.398-.082-.78-.225-1.133l5.16-2.58A2.993 2.993 0 0 0 14.25 6.75a3 3 0 1 0 0-6 3 3 0 0 0-3 3c0 .165.023.315.045.473l-5.393 2.7A2.996 2.996 0 0 0 3.75 6a3 3 0 1 0 0 6c.848 0 1.612-.352 2.152-.922l5.393 2.7c-.022.157-.045.307-.045.472a3 3 0 1 0 6 0 3 3 0 0 0-3-3Zm0-9.375a1.876 1.876 0 1 1-.001 3.751 1.876 1.876 0 0 1 .001-3.751Zm-10.5 9a1.876 1.876 0 1 1 .001-3.751 1.876 1.876 0 0 1-.001 3.751Zm10.5 5.25a1.876 1.876 0 1 1 .001-3.751 1.876 1.876 0 0 1-.001 3.751Z" clip-rule="evenodd"/></svg>';

    this.copy = this.copy.bind(this);

  }


  mount() {
    const share = e => {
      if (navigator.share) {
        navigator
          .share({
            url: this.shareUrl,
          })
          .then(() => console.log(""))
          .catch(error => console.log("error", error));

      }
    };

    if (window.isSecureContext && navigator.clipboard) {
      this.button.addEventListener("click", this.copy)
    } else {
      this.button.remove();
    }
  }

  copy() {
    this.svgDefult = this.buttonIcon;
    navigator.clipboard.writeText(this.shareUrl);
    this.buttonLabel.innerText="Done"
    this.buttonIcon.innerHTML = this.svgColler;
    setTimeout(() => {
      this.buttonLabel.innerText="Copy Link";
      this.buttonIcon.innerHTML = this.svgDefault
    }, "2000")
  }

  unmount() {
  }
}
